import { useEffect } from "react";
import { setAuthExpiredHandler, setServerErrorHandler } from "../api/client";
import { useAuth } from "../auth/store";
import { useDraft } from "../vault/draft";
import { useToast } from "./toast-context";

// Registers the app-wide API error policy (must be mounted inside ToastProvider). A 401 mid-session
// clears auth so the app returns to sign-in instead of a silent empty vault; a 5xx surfaces as a
// toast so a silent local catch can't hide a server fault. Renders nothing.
export function ApiErrorPolicy() {
  const toast = useToast();
  useEffect(() => {
    setAuthExpiredHandler(() => {
      // Guard against duplicate toasts when several in-flight requests 401 at once.
      if (!useAuth.getState().token) return;
      // NB: the auth clear bounces the app to sign-in and unmounts everything. An item edit in
      // progress survives in vault/draft.ts and is offered back after unlock — say so, because
      // otherwise this looks exactly like losing the work.
      const hasDraft = useDraft.getState().draft !== null;
      useAuth.getState().clear();
      toast.error(
        hasDraft
          ? "Your session expired — please sign in again. Your unsaved item is kept."
          : "Your session expired — please sign in again.",
      );
    });
    setServerErrorHandler((message) => toast.error(message));
    return () => {
      setAuthExpiredHandler(null);
      setServerErrorHandler(null);
    };
  }, [toast]);
  return null;
}
